<div class="construction-site-remark-root">
  <div class="popup">
    <div class="header">
      <div class="title">Chantier</div>
      <div class="separator"></div>
      <div class="description">Que se passe-t-il ? Dites nous tous</div>
    </div>

    <div class="content">
      <textarea [(ngModel)]="remark" placeholder="Votre message ici..."></textarea>
      <label for="file-upload" class="attachment">
        <img src="/assets/images/remark_attached.svg" />
      </label>
      <input (change)="onFileChange($event)" id="file-upload" type="file" />
      <button class="send" (click)="send()"><img src="/assets/images/remark_send.svg" /></button>

      <div class="attachment-text" *ngIf="base64File">Pièce jointe : {{ filename }}</div>
    </div>

    <fa-icon class="close" [icon]="['fas', 'times']" size="lg" (click)="closeRemark(false)"></fa-icon>
  </div>
</div>
